import React from 'react';
import { Coffee } from 'lucide-react';
import ImageProcessingOverlay from './ImageProcessingOverlay';

interface CoffeeCupMockupProps {
  designImage: string | null;
  templateImage: string | null;
  isLoading?: boolean;
  loadingMessages?: string[];
}

export function CoffeeCupMockup({ designImage, templateImage, isLoading, loadingMessages }: CoffeeCupMockupProps) {
  return (
    <div className="relative w-full h-96 md:h-[500px] bg-gradient-to-br from-amber-50 via-orange-50 to-amber-50 rounded-2xl border-2 border-amber-300 shadow-xl flex items-center justify-center overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-5">
          <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLXdpZHRoPSIxIi8+PC9wYXR0ZXJuPjwvZGVmcz48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSI2MCIgZmlsbD0idXJsKCNncmlkKSIvPjwvc3ZnPg==')]" />
        </div>

        {/* Cup Mockup Content */}
        <div className="absolute inset-0 flex items-center justify-center p-4">
            {designImage ? (
                <div className="relative max-w-md w-full h-full flex items-center justify-center">
                    <img
                      src={designImage}
                      alt="Coffee Grounds Cup Mockup with Laser Engraving"
                      className="max-h-full max-w-full object-contain drop-shadow-2xl rounded-lg"
                      loading="lazy"
                    />
                </div>
            ) : templateImage ? (
                <div className="relative max-w-md w-full h-full flex items-center justify-center">
                    <img
                      src={templateImage}
                      alt="Coffee Grounds Cup Template"
                      className="max-h-full max-w-full object-contain opacity-70"
                      loading="lazy"
                    />
                    {!isLoading && (
                        <div className="absolute inset-0 flex items-center justify-center">
                        <div className="bg-white/95 backdrop-blur-md rounded-xl px-6 py-5 shadow-xl border border-amber-200">
                            <Coffee className="w-10 h-10 text-amber-700 mx-auto mb-3" />
                            <p className="text-gray-800 font-semibold text-center mb-1">
                            Chọn mẫu cốc để xem thiết kế
                            </p>
                            <p className="text-gray-600 text-xs text-center">
                            Logo vàng/gold sẽ được in laser
                            </p>
                        </div>
                        </div>
                    )}
                </div>
            ) : (
                !isLoading && (
                    <div className="bg-white/95 backdrop-blur-md rounded-xl px-8 py-8 shadow-xl border border-amber-200">
                    <Coffee className="w-14 h-14 text-amber-700 mx-auto mb-4" />
                    <p className="text-gray-800 font-semibold text-center text-lg mb-2">
                        Chưa có mẫu cốc
                    </p>
                    <p className="text-gray-600 text-sm text-center">
                        Chọn mẫu cốc bã cà phê bên dưới
                    </p>
                    </div>
                )
            )}
        </div>

        {/* Enhanced Loading Overlay */}
        <ImageProcessingOverlay
            isLoading={!!isLoading}
            messages={loadingMessages}
            showShimmer={true}
            showPulse={true}
        />

        {/* Badges */}
        {designImage && !isLoading && (
          <>
            <div className="absolute top-4 right-4 bg-gradient-to-r from-amber-600 to-amber-700 text-white px-4 py-1.5 rounded-full text-xs font-semibold shadow-lg flex items-center gap-1.5 z-10">
              <span>✨</span>
              <span>AI Mockup</span>
            </div>
            <div className="absolute top-4 left-4 bg-gradient-to-r from-amber-800 to-amber-900 text-white px-4 py-1.5 rounded-full text-xs font-semibold shadow-lg flex items-center gap-1.5 z-10">
              <span>☕</span>
              <span>Cốc Bã Cà Phê</span>
            </div>
          </>
        )}
    </div>
  );
}